import { LocationArrowIcon, Typography } from '@iheartjane/reefer';

import { LocationArrowDisabledIcon } from '@jane/bloom/assets/icons/LocationArrowDisabledIcon';
import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';

import styles from './locationButton.module.css';

interface LocationButtonProps {
  triggerLocationPrompt: () => void;
}

export const LocationButton = ({
  triggerLocationPrompt,
}: LocationButtonProps) => {
  const { locationButtonDisabled } = useStoreSwitcher();

  return (
    /** @todo use elements with appropriate role */
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      className={styles['locationButtonContainer']}
      onClick={triggerLocationPrompt}
      aria-label="Get current location"
    >
      {locationButtonDisabled ? (
        <>
          <LocationArrowDisabledIcon />
          <Typography ml={8} color="inherit">
            Unable to access current location
          </Typography>
        </>
      ) : (
        <>
          <LocationArrowIcon
            altText="Black outlined target icon"
            color="inherit"
          />
          <Typography ml={8} color="inherit">
            Use current location
          </Typography>
        </>
      )}
    </div>
  );
};
